import XLSX from 'xlsx';
import { DocumentRowFilterType, IDocumentRow } from 'models/document-row';
import { getPriceWithoutVAT, getVatAmount } from 'helpers';
import moment from 'moment';
import { isoDateFormat } from 'common/dateFormatterConfig';
import { downloadFile } from './apiResponseHelper';

export const saveAsXLSX = (data: any, sheetName: string, type: 'xlsx' = 'xlsx') => {
    const now = moment().format('DD.MM.YYYYTHH_mm_SS');
    const sheet = XLSX.utils.aoa_to_sheet(data, { cellStyles: true } );

    let objectMaxLength: any[] = [];

    data.forEach((arr: any, index: number) => {
      if (index < 6) {
        return;
      }
      Object.keys(arr).forEach((key: any) => {
        let value = arr[key] === null ? '' : arr[key]

        if (typeof value === 'number')
        {
          return objectMaxLength[key] = 10
        }

        objectMaxLength[key] = objectMaxLength[key] >= value.length ? objectMaxLength[key]  : value.length
      })
    })

    let worksheetCols = objectMaxLength.map(width => {
      return {
        width
      }
    })

    sheet["!cols"] = worksheetCols;
    sheet["!merges"] = [
      {s: {r: 0, c: 0}, e: {r: 0, c: 9}},
      {s: {r: 1, c: 0}, e: {r: 1, c: 9}},
      {s: {r: 2, c: 0}, e: {r: 2, c: 9}},
      {s: {r: 3, c: 0}, e: {r: 3, c: 9}},
      {s: {r: 4, c: 0}, e: {r: 4, c: 9}},
      {s: {r: 5, c: 0}, e: {r: 5, c: 9}},
      {s: {r: 6, c: 0}, e: {r: 6, c: 9}}
    ]
    const workbook = XLSX.utils.book_new();
    workbook.SheetNames.push(sheetName);
    workbook.Sheets[sheetName] = sheet;
    const wopts: XLSX.WritingOptions = { bookType: type, bookSST: false, type: 'binary'};
    const wbout = XLSX.write(workbook, wopts);
    function s2ab(s: string) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
    }

    const xlsxBlob = new Blob([s2ab(wbout)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = sheetName+'_'+now+'.'+type;

    downloadFile(fileName, xlsxBlob, window.URL.createObjectURL(xlsxBlob))
}

export const convertDocumentRowsToSheet = (customer: string, filters: { [key in DocumentRowFilterType]?: any }, data: IDocumentRow[]) => {
  let period;
  if (filters.DATE) {
    const dateRange = (filters.DATE.startDate && filters.DATE.startDate.format('DD.MM.YYYY')) + ' - ' +
        (filters.DATE.endDate && filters.DATE.endDate.format('DD.MM.YYYY'));  
      period = dateRange;
  }
  const headers = ['Arve', 'Kuupäev', 'Asukoht', 'Kliendikaart', 'Nimi'];
  const hasCarRows = !!data.find(item => item.vehicleNumber || item.vehicleMileage);
  const sumRow: any[] = ['','','','',''];

  const totalSum = data.reduce((sum, a) => sum + a.productAmountSum, 0);
  const totalSumWithoutVat = data.reduce((acc, a) => acc + getPriceWithoutVAT(a.productAmountSum, moment(a.documentDateCreated)), 0)
  const totalVat = data.reduce((acc, a) => acc + Number(getVatAmount(a.productAmountSum, moment(a.documentDateCreated))), 0)

  if (hasCarRows) {
    headers.push('Autonumber', 'Odomeetri näit');
    sumRow.push('','')
  }
  sumRow.push('','','Kokku:', Math.round(totalSum * 100) / 100, totalSumWithoutVat, totalVat);
  headers.push('Kauba nimetus', 'Hind', 'Kogus', 'Summa', 'Summa KM-ta', 'Käibemaks');
  return [
    ['Müügiarvete väljavõte'],
    [customer],
    ['Periood: ' + (period ? period : '-')],
    ['Kaart: ' + (filters.CARD ? filters.CARD.value.remoteCardId : 'kõik kaardid')],
    ['Nimi: ' + (filters.NAME ? filters.NAME.value : '-')],
    ['Tankla: ' + (filters.LOCATION ? filters.LOCATION.value : 'kõik tanklad')],
    [],
    headers,
    ...data.map(d => {
      const row: any[] = [
        d.documentNumber,
        d.documentDateCreated ? moment(d.documentDateCreated).format(isoDateFormat) : '',
        d.locationName || '-',
        d.remoteCardId || '-',
        d.cardName || '-',        
      ];
      if (hasCarRows) {
        row.push((d.vehicleNumber || '-'), (d.vehicleMileage || '-'));
      }
      row.push(
        d.productName || '-',
        d.price || '-',
        d.productQuantity || '-',
        d.productAmountSum,
        d.productAmountSum !== null ? Number(getPriceWithoutVAT(d.productAmountSum, moment(d.documentDateCreated), 2)) : null,
        d.productAmountSum !== null ? Number(getVatAmount(d.productAmountSum, moment(d.documentDateCreated), 2)) : null
      );
      return row;
    }),
    sumRow
    ];
}